/**
 * Enum to represent special actions for linkCode
 */
export var LinkCodeAction;
(function (LinkCodeAction) {
    /**
     * Request to generate a new link code
     */
    LinkCodeAction["GENERATE"] = "GENERATE_NEW_LINK_CODE";
})(LinkCodeAction || (LinkCodeAction = {}));
/**
 * Enum to represent special actions for link status
 */
export var LinkStatusAction;
(function (LinkStatusAction) {
    /**
     * Request to enable the audience link
     */
    LinkStatusAction["ENABLE_LINK"] = "ENABLE_AUDIENCE_LINK";
    /**
     * Request to disable the audience link
     */
    LinkStatusAction["DISABLE_LINK"] = "DISABLE_AUDIENCE_LINK";
})(LinkStatusAction || (LinkStatusAction = {}));
/**
 * Converts a ServiceAudienceLinkInfo (BE) -> AudienceLinkInfo (FE)
 * @param serviceLinkInfo The service model format of audience link info
 * @param dmpId Optional DMP ID to include in the result
 * @param orgId Optional organization ID to include in the result
 * @returns The frontend model format of audience link info
 */
export const serviceAudienceLinkInfoToAudienceLinkInfo = (serviceLinkInfo, dmpId, orgId) => {
    // Generate composite ID if both orgId and dmpId are provided
    const id = orgId && dmpId ? `${orgId},${dmpId}` : undefined;
    return {
        id,
        enabled: serviceLinkInfo.enabled,
        bucketName: serviceLinkInfo.bucket_name,
        cloudProvider: serviceLinkInfo.cloud_provider,
        objectPath: serviceLinkInfo.object_path,
        linkCode: serviceLinkInfo.link_code,
        updatedAt: serviceLinkInfo.updated_at,
        dmpId,
        orgId
    };
};
/**
 * Converts a AudienceLinkInfo (FE) -> ServiceAudienceLinkInfo (BE)
 * @param linkInfo The frontend model format of audience link info
 * @returns The service model format of audience link info
 */
export const audienceLinkInfoToServiceAudienceLinkInfo = (linkInfo) => {
    // Convert LinkStatusAction to boolean if needed
    let enabledValue;
    if (linkInfo.enabled === LinkStatusAction.ENABLE_LINK) {
        enabledValue = true;
    }
    else if (linkInfo.enabled === LinkStatusAction.DISABLE_LINK) {
        enabledValue = false;
    }
    else {
        enabledValue = linkInfo.enabled;
    }
    return {
        enabled: enabledValue,
        bucket_name: linkInfo.bucketName,
        cloud_provider: linkInfo.cloudProvider,
        object_path: linkInfo.objectPath,
        link_code: typeof linkInfo.linkCode === "string" ? linkInfo.linkCode : undefined,
        updated_at: linkInfo.updatedAt
    };
};
/**
 * Converts a ServiceGenerateLinkCodeResponse (BE) -> GenerateLinkCodeResponse (FE)
 * @param response The service response format
 * @returns The frontend response format
 */
export const serviceGenerateLinkCodeResponseToGenerateLinkCodeResponse = (response) => {
    return {
        linkCode: response.link_code,
        dmpId: response.dmp_id
    };
};
/**
 * Converts a ServiceToggleAudienceLinkResponse (BE) -> ToggleAudienceLinkResponse (FE)
 * @param response The service response format
 * @returns The frontend response format
 */
export const serviceToggleAudienceLinkResponseToToggleAudienceLinkResponse = (response) => {
    return {
        dmpId: response.dmp_id,
        enabled: response.enabled
    };
};
/**
 * Converts a DeliveryPathRequest (FE) -> ServiceDeliveryPathRequest (BE)
 * @param request The frontend request format
 * @returns The service request format
 */
export const deliveryPathRequestToServiceDeliveryPathRequest = (request) => {
    return {
        bucket_name: request.bucketName,
        object_path: request.objectPath,
        cloud_provider: request.cloudProvider
    };
};
//# sourceMappingURL=audienceLinks.js.map